import { IExportColumnModel } from '../../../../../shared/models/export.column.model'

export const SubscriptionCategoryColumnList: IExportColumnModel[] = [
]